var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { NewResidentBanner, Radio } from "./styles";
import { Column } from "../../../table/Column";
import { CellRenderer } from "./CellRenderer";
import { Table } from "../../../table/Table";
import { NEW_RESIDENT } from "./types";
import { normalizeString, parseDate } from "./utils/helpers";
export var NewResident = function (_a) {
    var formValues = _a.formValues, _b = _a.selectable, selectable = _b === void 0 ? true : _b, _c = _a.hasSimilarResidents, hasSimilarResidents = _c === void 0 ? false : _c, _d = _a.hasDuplicate, hasDuplicate = _d === void 0 ? false : _d, duplicateResident = _a.duplicateResident, residentFilesModal = _a.residentFilesModal;
    var NEW_RESIDENT_TABLE_ITEM = React.useMemo(function () { return ({
        match: NEW_RESIDENT,
        resident: __assign(__assign({}, formValues), { id: NEW_RESIDENT }),
    }); }, [formValues]);
    var areStringsEqual = React.useCallback(function (val1, val2) {
        return normalizeString(val1 || "") === normalizeString(val2 || "");
    }, []);
    return (React.createElement(NewResidentBanner, { hasSimilarResidents: hasSimilarResidents, hasDuplicate: hasDuplicate, selectable: selectable },
        React.createElement(Table, { data: hasDuplicate ? [duplicateResident] : [NEW_RESIDENT_TABLE_ITEM], getRowId: function (_a) {
                var _b;
                var rowData = _a.rowData;
                return ((_b = rowData === null || rowData === void 0 ? void 0 : rowData.resident) === null || _b === void 0 ? void 0 : _b.id) || "unknown";
            } },
            React.createElement(Column, { cellRenderer: function (_a) {
                    var rowData = _a.rowData;
                    return (React.createElement(Radio, { id: "similar_resident_radio", onClick: function (e) {
                            e.stopPropagation();
                        }, visible: selectable, name: "resident_demographics.similar_resident", type: "radio", value: rowData.resident.id }));
                }, width: 100 }),
            React.createElement(Column, { cellRenderer: function (_a) {
                    var rowData = _a.rowData;
                    return CellRenderer({
                        label: "First name",
                        value: rowData.resident.first_name || "—",
                    }, areStringsEqual(formValues.first_name, rowData.resident.first_name));
                }, label: "First Name", width: 250 }),
            React.createElement(Column, { cellRenderer: function (_a) {
                    var rowData = _a.rowData;
                    return CellRenderer({
                        label: "Last name",
                        value: rowData.resident.last_name || "—",
                    }, areStringsEqual(formValues.last_name, rowData.resident.last_name));
                }, label: "Last Name", width: 250 }),
            React.createElement(Column, { cellRenderer: function (_a) {
                    var rowData = _a.rowData;
                    return CellRenderer({ label: "Gender", value: rowData.resident.gender || "—" }, formValues.gender === rowData.resident.gender);
                }, label: "Gender", width: 150 }),
            React.createElement(Column, { cellRenderer: function (_a) {
                    var rowData = _a.rowData;
                    return CellRenderer({
                        label: "Date of birth",
                        value: rowData.resident.date_of_birth
                            ? parseDate(rowData.resident.date_of_birth)
                            : "—",
                    }, formValues.date_of_birth === rowData.resident.date_of_birth);
                }, label: "Date of Birth", width: 150 }),
            React.createElement(Column, { cellRenderer: function (_a) {
                    var rowData = _a.rowData, rowIndex = _a.rowIndex;
                    return (hasDuplicate &&
                        residentFilesModal && (React.createElement("div", { style: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "16px",
                        } }, residentFilesModal({
                        rowData: rowData,
                        rowIndex: rowIndex,
                    }))));
                }, width: hasDuplicate ? 150 : 10 }))));
};
